import { gql } from "@apollo/client/core";

export const NOTIFY_BACK_IN_STOCK = gql`
  mutation notifyBackInStock(
    $email: String!
    $variantSku: String!
    $locale: String!
  ) {
    notifyBackInStock(email: $email, variantSku: $variantSku, locale: $locale)
  }
`;
